import { assessmentGeneratedApi } from '@/api'

export default {
  namespaced: true,

  state: {
    testScheduleCells: null,
    testSchedule: null
  },

  getters: {
    getTestSchedule: state => state.testSchedule,
    testScheduleCells: state => state.testScheduleCells
  },

  mutations: {
    SET_SCHEDULE_CELLS(state, payload) {
      state.testScheduleCells = payload
    },

    SET_SCHEDULE(state, payload) {
      state.testSchedule = payload
    }
  },

  actions: {
    async getScheduleCells({ commit }, id) {
      try {
        const response = await assessmentGeneratedApi.getScheduleCells(id)
        commit('SET_SCHEDULE_CELLS', response)
      } catch (e) {
        console.log(e)
      }
    },

    async getSchedule({ commit }, id) {
      try {
        const response = await assessmentGeneratedApi.getSchedule(id)
        commit('SET_SCHEDULE', response)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
